// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as TiendasActions } from '../duck';
import LandingTiendas from '../components/LandingTiendas';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
    isRegistering: state.tiendas.isRegistering,
    registrationSuccess: state.tiendas.registrationSuccess,
    registrationError: state.tiendas.registrationError,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...TiendasActions,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LandingTiendas);



// WEBPACK FOOTER //
// ./src/modules/tiendas/containers/LandingTiendasContainer.js